import { Divider } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import LinksSection from './LinksSection';
import PrivacySection from './PrivacySection';
import SocialSection from './SocialSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const MainFooter = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl
  } = _ref;
  return /*#__PURE__*/_jsx("footer", {
    className: "main-footer",
    children: /*#__PURE__*/_jsx("div", {
      className: "main-footer__content tear tear--top",
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsxs(SeparatedList, {
          separator: /*#__PURE__*/_jsx(Divider, {}),
          children: [/*#__PURE__*/_jsx(LinksSection, {
            isBusinessInfoLinksEnabled: isBusinessInfoLinksEnabled
          }), /*#__PURE__*/_jsx(SocialSection, {}), /*#__PURE__*/_jsx(PrivacySection, {
            isDigitalLawEnabled: isDigitalLawEnabled,
            isBusinessInfoLinksEnabled: isBusinessInfoLinksEnabled,
            onlineComplaintUrl: onlineComplaintUrl
          })]
        })
      })
    })
  });
};

export default MainFooter;